const jobPostCreation = window.location.pathname.match(/\/jobs|works|franchise_jobs/);
const admin_path = window.location.pathname.includes('franchise_admin') ? 'franchise_admin' : 'admin'

if (jobPostCreation) {
  document.addEventListener('DOMContentLoaded', function () {
    const userSelect = document.getElementById('user-select');
    const addressWrapper = document.getElementById('user-address-select-wrapper');
    const addressSelect = document.getElementById('user-address-select');

    if (!userSelect || !addressWrapper || !addressSelect) return;

    userSelect.addEventListener('change', function () {
      const userId = this.value;
      if (!userId) {
        addressWrapper.style.display = 'none';
        addressSelect.innerHTML = '';
        return;
      }
      fetch(`/${admin_path}/users/${userId}/addresses`)
      .then(response => response.json())
      .then(data => {
        addressSelect.innerHTML = '<option value="">None</option>';
        data.forEach(address => {
          const option = document.createElement('option');
          option.value = address.id;
          option.textContent = address.full_address;
          addressSelect.appendChild(option);
        });
        addressWrapper.style.display = data.length > 0 ? 'block' : 'none';
      });
    });
  });
}
